import cls from "./customInnerPage.module.scss";
import {
    FacebookIcon,
    FacebookShareButton,
    PinterestIcon,
    PinterestShareButton,
    TwitterIcon,
    TwitterShareButton
} from "next-share";
import {domainUrl} from "../../../helper";
import React, {FC} from "react";

const CustomSocialLinks: FC<Record<string, string>> = ({
                                                           dbName,
                                                           productSlug,
                                                           domain
                                                       }) => (
    <div className={cls["socialLinksBox"]}>
        <FacebookShareButton url={`https://${dbName}/products/${productSlug}`}>
            <FacebookIcon size={32} round/>
        </FacebookShareButton>
        <TwitterShareButton url={`https://${dbName}/products/${productSlug}`}>
            <TwitterIcon size={32} round/>
        </TwitterShareButton>
        <PinterestShareButton
            url={`https://${dbName}/products/${productSlug}`}
            media={domainUrl(`${dbName}/storage/${domain}/configuration/logo/logo.webp`)}
        >
            <PinterestIcon size={32} round/>
        </PinterestShareButton>
    </div>
)

export default CustomSocialLinks